var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-wrapper"},[_c('v-img',_vm._b({attrs:{"src":_vm.src,"aspect-ratio":4/3}},'v-img',_vm.$attrs,false)),(_vm.isVideo)?_c('v-icon',{attrs:{"color":"mainRed","large":""}},[_vm._v(" mdi-youtube ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }